import { render, staticRenderFns } from "./AsMngCallList.vue?vue&type=template&id=bec594c2&scoped=true"
import script from "./AsMngCallList.vue?vue&type=script&lang=js"
export * from "./AsMngCallList.vue?vue&type=script&lang=js"
import style0 from "./AsMngCallList.vue?vue&type=style&index=0&id=bec594c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec594c2",
  null
  
)

export default component.exports